export default __webpack_public_path__ + "static/media/1867.cd4b43f2.png";